import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Sel } from "./Fields";
import { useI18n } from "../lib/i18n";
import { useSite } from "../lib/site";
import { fmtSAR } from "../lib/format";

const BUDGETS = [500000, 1000000, 2000000, 3000000, 5000000, 10000000, 20000000];

export default function SearchBar() {
  const { t, tr, lang } = useI18n();
  const { locations, byKind } = useSite();
  const nav = useNavigate();
  const [f, setF] = useState({ purpose: "sale", city: "", type: "", min_price: "", max_price: "" });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const go = (e) => {
    e.preventDefault();
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v));
    nav(`/properties?${q.toString()}`);
  };
  const budget = BUDGETS.map((b) => [b, fmtSAR(b, lang)]);
  return (
    <form onSubmit={go} data-testid="hero-search-form" className="on-media glass-strong w-full max-w-5xl rounded-sm p-4 shadow-2xl md:p-5">
      <div className="mb-4 flex gap-1" role="radiogroup" aria-label={t("search.purpose")}>
        {["sale", "rent", "investment"].map((p) => (
          <button key={p} type="button" role="radio" aria-checked={f.purpose === p} data-testid={`hero-search-purpose-${p}`} onClick={() => set("purpose")(p)}
            className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${f.purpose === p ? "bg-cta text-canvas" : "text-fg/70 hover:text-cta"}`}>{t(`purpose.${p}`)}</button>
        ))}
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1fr_auto]">
        <Sel testid="hero-search-city" label={t("search.city")} value={f.city} onChange={set("city")} placeholder={t("search.anyCity")} options={locations.map((l) => [l.slug, tr(l, "name")])} />
        <Sel testid="hero-search-type" label={t("search.type")} value={f.type} onChange={set("type")} placeholder={t("search.anyType")} options={byKind("property_type").map((c) => [c.key, tr(c, "label")])} />
        <Sel testid="hero-search-min-price" label={t("search.min")} value={f.min_price} onChange={set("min_price")} placeholder={t("search.noMin")} options={budget} />
        <Sel testid="hero-search-max-price" label={t("search.max")} value={f.max_price} onChange={set("max_price")} placeholder={t("search.noMax")} options={budget} />
        <button type="submit" data-testid="hero-search-submit" className="btn-cta h-12 !rounded-sm"><Search className="h-4 w-4" />{t("search.search")}</button>
      </div>
    </form>
  );
}
